import React, { ReactNode, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { HashRouter } from "react-router-dom";
import { StoreProvider } from "easy-peasy";

import store from "store/store";
import Theme from "theme/theme";

type Props = {
  children: ReactNode;
};

const Providers = ({ children }: Props) => {
  const methods = useForm({ shouldFocusError: true, mode: "all" });
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  return (
    <HashRouter>
      <StoreProvider store={store}>
        <Theme isMobile={isMobile}>
          <FormProvider {...methods}>{children}</FormProvider>
        </Theme>
      </StoreProvider>
    </HashRouter>
  );
};

export default Providers;
